const logOutRoute = {
  title: "Logout",
  icon: require("@/assets/icons/documentation-icon.svg"),
  route: "Login",
};

const documents = {
  title: "Documents",
  icon: require("@/assets/icons/documentation-icon.svg"),
  children: [
    {
      title: "Quick Start Guide",
      external: true,
      link: "https://www.mastermindsports.com/quick-start-guide",
    },
    {
      title: "Training Program",
      external: true,
      link: "https://www.mastermindsports.com/training-program-overview",
    },
    {
      title: "Assessment Overview",
      external: true,
      link: "https://www.mastermindsports.com/assessment-overview",
    },
    {
      title: "Terms of Service",
      external: true,
      link: "https://www.mastermindsports.com/terms-of-service",
    },
    {
      title: "Privacy Policy",
      external: true,
      link: "https://www.mastermindsports.com/privacy-policy",
    },
  ],
};

export const internalUserRoutes = {
  topRoutes: [
    {
      title: "Dashboard",
      icon: require("@/assets/icons/dashboard-icon.svg"),
      route: "Home",
    },
    {
      title: "Manage Organization Users",
      icon: require("@/assets/icons/sponsors-icon.svg"),
      route: "Manage players",
    },
    {
      title: "Delegates",
      icon: require("@/assets/icons/users-icon.svg"),
      route: "Manage location",
    },
    documents,
    {
      title: "Assessment Tracking",
      icon: require("@/assets/icons/assessment-icon.svg"),
      children: [
        {
          title: "Compare by individual user",
          route: "User Assessment Scores",
        },
        {
          title: "Compare by assessment",
          route: "Assessment overview",
        },
      ],
    },
    {
      title: "Account",
      icon: require("@/assets/icons/profile-icon.svg"),
      route: "User Payments",
    },
    {
      title: "Settings",
      icon: require("@/assets/icons/settings-icon.svg"),
      route: "Settings Profile",
    },
    logOutRoute,
  ],
  bottomRoutes: [],
};

export const generalUserRoutes = {
  topRoutes: [
    {
      title: "Games Overviews",
      icon: require("@/assets/icons/documentation-icon.svg"),
      route: "Games VR",
    },
    documents,
    {
      title: "Assessment",
      icon: require("@/assets/icons/assessment-icon.svg"),
      route: "Assessment Report",
    },
    {
      title: "Account Settings",
      icon: require("@/assets/icons/profile-icon.svg"),
      children: [
        {
          title: "Personal Information",
          route: "Settings Profile",
        },
        {
          title: "Players",
          route: "Players",
        },
      ],
    },
    logOutRoute,
  ],
  bottomRoutes: [],
};

export const adminUserRoutes = {
  topRoutes: [
    {
      title: "Dashboard",
      icon: require("@/assets/icons/dashboard-icon.svg"),
      route: "Home",
    },
    {
      title: "Location",
      icon: require("@/assets/icons/location-admin-icon.svg"),
      route: "Location Admin",
    },
    {
      title: "Settings",
      icon: require("@/assets/icons/settings-icon.svg"),
      route: "Settings Profile",
    },
    logOutRoute,
  ],
  bottomRoutes: [],
};
